import React, { useEffect, useState } from "react";
import styles from "./OperatorCalib.module.scss";

import Button from "../../UiComponents/Button";
import Loader from "../../UiComponents/loader/Loader";
import Success from "../../UiComponents/sucess/Success";
import operatorImg from "../../../pics/Operator.png";
import imageDragon from "../../../pics/dragonFly.png";

import {
  displayCalibValue,
  ticksToDate,
  ticksToDateYearMonthDay,
} from "../../calibration/functionDataSorted";

import Axios from "../../../_services/caller.service";
import { convertDateToTicks } from "../../../utils/handleDateTicks";
import download from "downloadjs";
import ModalNotGoodOupout from "./Modal/ModalNotGoodOupout";
import ModalComfirmImport from "./Modal/ModalComfirmImport";
import ModalConfirmRegisterNewValue from "./Modal/ModalConfirmRegisterNewValue";
import { decodedB64, encodedB64 } from "../../../CustomHooks/DecodedBase64";
import { toast } from "react-toastify";
import LoaderLogin from "../../UiComponents/loader/LoaderLogin";
import { PermissionGate } from "../managePermissions/PermissionGate";
import { useTranslation } from "react-i18next";

const OperatorCalib = ({ cabId, setCabId, cabname, onCalibrationSaved }) => {
  const { t } = useTranslation();
  // CALIBRATION
  const [calibGeneral, setCalibGeneral] = useState("");
  const [calibVocalLeft, setCalibVocalLeft] = useState([]);
  const [calibVocalRight, setCalibVocalRight] = useState([]);
  //SERIAL NUMBER
  const [serialNumber, setSerialNumber] = useState("");
  const [serialSoundcardNumber, setSerialSoundcardNumber] = useState("");
  const [importSerialNumber, setImportSerialNumber] = useState(true);
  const [importSoundcardSerial, setImportSoundcardSerial] = useState(true);

  //DISPLAY
  const [dateCalibration, setDateCalibration] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSucess] = useState(false);
  const [maj, setMaj] = useState(false);
  //LOADING
  const [loadingVoc, setloadingVoc] = useState(true);
  const [loadingGen, setloadingGen] = useState(true);
  const [loadingAllData, setLoadingAllData] = useState(true);
  //IMPORT EXPORT
  const [selectedFile, setSelectedFile] = useState();
  const [modalConfirmImport, setModalConfirmImport] = useState(false);
  const [modalConfirmRegisterNewValue, setModalConfirmRegisterNewValue] =
    useState(false);
  const [modalNotGoodOutpout, setModalNotGoodOutpout] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [isCheckedDateUpdate, setIsCheckedDateUpdate] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");

  const [previousCalibGeneral, setPreviousCalibGeneral] = useState("");
  const [previousCalibVocalLeft, setPreviousCalibVocalLeft] = useState([]);
  const [previousCalibVocalRight, setPreviousCalibVocalRight] = useState([]);
  const [previousDateCalibration, setPreviousDateCalibration] = useState("");
  const [previousSerialNumber, setPreviousSerialNumber] = useState("");
  const [previousSerialSoundcardNumber, setPreviousSerialSoundcardNumber] =
    useState("");
  const [importedSerialNumber, setImportedSerialNumber] = useState("");
  const [importedSoundcardSerialNumber, setImportedSoundcardSerialNumber] =
    useState("");
  const [isImportMode, setIsImportMode] = useState(false);

  useEffect(() => {
    if (cabId !== "") {
      const controller = new AbortController();
      const signal = controller.signal;

      const fetchGeneral = Axios.get(`/calibrationGeneral/${cabId}`, { signal })
        .then((response) => {
          setloadingGen(false);
          if (response.data.message === "aucune donnée") {
            setCalibGeneral("0");
          } else {
            const allValue = response.data.data;
            const valueGeneral = displayCalibValue(allValue, "Operator_Value");
            const serialNumberOp = displayCalibValue(allValue, "Operator_Serial");
            setSerialNumber(decodedB64(serialNumberOp));
            const serialNumberCard = displayCalibValue(allValue, "Operator_Soundcard_Serial");
            setSerialSoundcardNumber(decodedB64(serialNumberCard));
            if (valueGeneral.length >= 1) {
              setCalibGeneral(valueGeneral[0]);
            } else {
              setCalibGeneral("0");
            }
            const dateGeneral = displayCalibValue(allValue, "Operator_Passed")[0];
            return dateGeneral;
          }
        })
        .catch((error) => {
          if (error.name !== "CanceledError") console.log(error);
        });

      const fetchVocal = Axios.get(`/calibrationVocal/${cabId}`, { signal })
        .then((response) => {
          setloadingVoc(false);
          if (response.data.message === "aucune donnée") {
            setCalibVocalLeft("0");
            setCalibVocalRight("0");
          } else {
            const allValue = response.data.data;
            const valueVocal = displayCalibValue(allValue, "Operator_Value");
            if (valueVocal.length >= 1) {
              const dataLeft = valueVocal[0].split(",").slice(0, 1);
              const dataRight = valueVocal[0].split(",").slice(1, 2);
              setCalibVocalLeft(dataLeft);
              setCalibVocalRight(dataRight);
            } else {
              setCalibVocalLeft("0");
              setCalibVocalRight("0");
            }
            const dateVocal = displayCalibValue(allValue, "Operator_Passed")[0];
            return dateVocal;
          }
        })
        .catch((error) => {
          if (error.name !== "CanceledError") console.log(error);
        });

      Promise.all([fetchGeneral, fetchVocal]).then(
        ([dateGeneral, dateVocal]) => {
          const allDatesExist = dateGeneral && dateVocal;
          if (allDatesExist) {
            setDateCalibration(dateGeneral);
            setWarningMessage("");
          } else {
            setDateCalibration("");
            setCalibGeneral("0");
            setCalibVocalLeft("0");
            setCalibVocalRight("0");
          }
        }
      );

      return () => {
        controller.abort();
      };
    }
  }, [cabId, setCabId, maj]);

  const registerNewValueOperator = () => {
    const finalSerialNumber = isImportMode
      ? importSerialNumber
        ? importedSerialNumber
        : previousSerialNumber
      : serialNumber;

    const finalSerialSoundcardNumber = isImportMode
      ? importSoundcardSerial
        ? importedSoundcardSerialNumber
        : previousSerialSoundcardNumber
      : serialSoundcardNumber;

    const serialNumberEncoded = finalSerialNumber
      ? encodedB64(finalSerialNumber)
      : "";
    const serialNumberSoundCardEncoded = finalSerialSoundcardNumber
      ? encodedB64(finalSerialSoundcardNumber)
      : "";

    const date =
      isCheckedDateUpdate || !dateCalibration
        ? convertDateToTicks()
        : dateCalibration;

    Axios.post(`/createCatid/${cabId}`)
      .then((response) => {
        toast.success(response.data.message);

        Axios.put(`/newValueOperatorGeneral/${cabId}`, {
          data: { calibGeneral: calibGeneral, date: date },
        })
          .then(() => setLoading(false))
          .catch((error) => console.log(error));

        Axios.put(`/newValueOperatorSerial/${cabId}`, {
          data: serialNumberEncoded,
        })
          .then(() => setLoading(false))
          .catch((error) => console.log(error));

        Axios.put(`/newValueOperatorSoundcardSerial/${cabId}`, {
          data: serialNumberSoundCardEncoded,
        })
          .then(() => setLoading(false))
          .catch((error) => console.log(error));

        Axios.put(`/newValueOperatorVocal/${cabId}`, {
          calibVocalLeft: calibVocalLeft,
          calibVocalRight: calibVocalRight,
          date: date,
        })
          .then(() => {
            setOverlay(false);
            setModalConfirmImport(false);
            setModalConfirmRegisterNewValue(false);
            setMaj(!maj);
            toast.success(t("calibration_data.all_data_saved"));
            if (onCalibrationSaved) onCalibrationSaved();
          })
          .catch((error) => console.log(error));
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.message, { autoClose: false });
        } else {
          toast.error(
            "une erreur s'est produite lors de la création des catid",
            { autoClose: false }
          );
        }
      });
  };

  const checkHandler = () => {
    setIsCheckedDateUpdate(!isCheckedDateUpdate);
  };

  //IMPORT AND EXPORT CALIBRATION DATA
  const exportCalibDataOperator = async () => {
    const calibDate = ticksToDateYearMonthDay(dateCalibration);

    const arrayVocalLeft = Array.isArray(calibVocalLeft)
      ? calibVocalLeft
      : [calibVocalLeft];
    const arrayVocalRight = Array.isArray(calibVocalRight)
      ? calibVocalRight
      : [calibVocalRight];
    const allValueVocal = arrayVocalLeft.concat(arrayVocalRight);

    const data = {
      Eoutpout: "Operator",
      date: dateCalibration,
      general: calibGeneral,
      vocal: allValueVocal,
      serialNumber: serialNumber,
      serialSoundcardNumber: serialSoundcardNumber,
    };

    const dataStr = JSON.stringify(data);
    const filename = `Operator Calibration Data - ${serialNumber} - ${serialSoundcardNumber} - [${cabname}(${cabId})] - ${calibDate}.txt`;
    download(dataStr, filename, "text/plain");
  };

  const fileChangedHandler = (file) => {
    setSelectedFile(file);
  };

  useEffect(() => {
    if (selectedFile) {
      importCalibDataOperator();
    }
  }, [selectedFile]);

  const importCalibDataOperator = () => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      const text = e.target.result;
      const data = JSON.parse(text);

      if (data.Eoutpout !== "Operator") {
        setModalNotGoodOutpout(true);
        setOverlay(true);
        return;
      }

      const opGeneral = data.general;
      const opVocalLeft = data.vocal.slice(0, 1);
      const opVocalRight = data.vocal.slice(1, 2);
      const date = data.date;
      const importedSerial = data.serialNumber || "";
      const importedSerialSoundcard = data.serialSoundcardNumber || "";

      setPreviousCalibGeneral(calibGeneral);
      setPreviousCalibVocalLeft(calibVocalLeft);
      setPreviousCalibVocalRight(calibVocalRight);
      setPreviousDateCalibration(date);
      setPreviousSerialNumber(serialNumber);
      setPreviousSerialSoundcardNumber(serialSoundcardNumber);

      setCalibGeneral(opGeneral);
      setCalibVocalLeft(opVocalLeft);
      setCalibVocalRight(opVocalRight);
      setDateCalibration(date);

      setIsImportMode(true);

      if (importedSerial) setSerialNumber(importedSerial);
      if (importedSerialSoundcard) setSerialSoundcardNumber(importedSerialSoundcard);

      setImportedSerialNumber(importedSerial);
      setImportedSoundcardSerialNumber(importedSerialSoundcard);
      setModalConfirmImport(true);
      setOverlay(true);
    };

    reader.readAsText(selectedFile);
  };

  const handleSerialNumberChange = (importSerial, importSoundcard) => {
    setSerialNumber(importSerial ? importedSerialNumber : previousSerialNumber);
    setSerialSoundcardNumber(
      importSoundcard ? importedSoundcardSerialNumber : previousSerialSoundcardNumber
    );
  };

  useEffect(() => {
    if (!loadingGen && !loadingVoc) {
      setLoadingAllData(false);
    }
  }, [loadingGen, loadingVoc]);

  return (
    <>
      {loadingAllData && <LoaderLogin />}

      <div className={styles.containerBoneCalib}>
        {overlay && <div className={styles.overlay}></div>}
        <div className={styles.cabnameAndType}>
          <h2>Calibration Operator ➡️ </h2>
          <h3>
            {cabname}({cabId})
          </h3>
        </div>
        <div className={styles.containerBtnExport}>
          <PermissionGate actionKey="cabines.operator.calibration.export">
            <Button
              onPress={exportCalibDataOperator}
              styles={"btnExport"}
              text={t("calibration_data.export")}
            />
          </PermissionGate>
          <div className={styles.containerImport}>
            <div className={styles.containerInputImport}>
              <label className={styles.uploadLabel}>
                {t("calibration_data.select_file")}
                <PermissionGate actionKey="cabines.operator.calibration.import">
                  <input
                    type="file"
                    onChange={(e) => fileChangedHandler(e.target.files[0])}
                    className={styles.hiddenInput}
                  />
                </PermissionGate>
              </label>
            </div>
          </div>
        </div>
        {modalNotGoodOutpout && (
          <ModalNotGoodOupout
            setOverlay={setOverlay}
            setModalNotGoodOutpout={setModalNotGoodOutpout}
          />
        )}

        {/* Correction générale */}
        <div className={styles.containerValue}>
          <div className={styles.general}>
            <h4>{t("calibration_data.general_correction")}</h4>
            <input
              onChange={(e) => setCalibGeneral(e.target.value)}
              onWheel={() => document.activeElement.blur()}
              value={calibGeneral}
              type="number"
              step="0.1"
            />
          </div>

          <h5>{t("calibration_data.vocal_correction")}</h5>
          <table className={styles.calibTable}>
            <tbody>
              <tr>
                <td className={styles.rowLabel}>G</td>
                <td>
                  <input
                    onChange={(e) => setCalibVocalLeft(e.target.value)}
                    onWheel={() => document.activeElement.blur()}
                    type="number"
                    step="0.1"
                    value={calibVocalLeft}
                  />
                </td>
              </tr>
              <tr>
                <td className={styles.rowLabel}>D</td>
                <td>
                  <input
                    onChange={(e) => setCalibVocalRight(e.target.value)}
                    onWheel={() => document.activeElement.blur()}
                    type="number"
                    step="0.1"
                    value={calibVocalRight}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* SERIAL */}
        <div className={styles.containerAllSerial}>
          <div className={styles.containerSerial}>
            <div className={styles.serial}>
              <h4>{t("calibration_data.operator_serial")}</h4>
              <input
                onChange={(e) => setSerialNumber(e.target.value)}
                type="text"
                value={serialNumber}
              />
              <img src={operatorImg} alt="" />
            </div>
            <div className={styles.serial}>
              <h4>{t("calibration_data.soundcard_serial")}</h4>
              <input
                onChange={(e) => setSerialSoundcardNumber(e.target.value)}
                type="text"
                value={serialSoundcardNumber}
              />
              <img src={imageDragon} alt="" />
            </div>
          </div>
        </div>
        <div className={styles.containerBtn}>
          <PermissionGate actionKey="cabines.operator.calibration.update">
            <Button
              onPress={() => {
                setOverlay(true);
                setModalConfirmRegisterNewValue(true);
                isImportMode && setIsImportMode(false);
              }}
              styles={"btnValidation"}
              text={t("calibration_data.save_new_values")}
            />
          </PermissionGate>
          {(modalConfirmRegisterNewValue || modalConfirmImport) && (
            <ModalConfirmRegisterNewValue
              setModalConfirmImport={setModalConfirmImport}
              setModalConfirmRegisterNewValue={setModalConfirmRegisterNewValue}
              setOverlay={setOverlay}
              isCheckedDateUpdate={isCheckedDateUpdate}
              checkHandler={checkHandler}
              importSerialNumber={importSerialNumber}
              setImportSerialNumber={setImportSerialNumber}
              importSoundcardSerial={importSoundcardSerial}
              setImportSoundcardSerial={setImportSoundcardSerial}
              registerNewValue={registerNewValueOperator}
              setCalibGeneral={setCalibGeneral}
              setCalibVocalLeft={setCalibVocalLeft}
              setCalibVocalRight={setCalibVocalRight}
              setDateCalibration={setDateCalibration}
              setSerialNumber={setSerialNumber}
              setSerialSoundcardNumber={setSerialSoundcardNumber}
              previousCalibGeneral={previousCalibGeneral}
              previousCalibVocalLeft={previousCalibVocalLeft}
              previousCalibVocalRight={previousCalibVocalRight}
              previousDateCalibration={previousDateCalibration}
              previousSerialNumber={previousSerialNumber}
              previousSerialSoundcardNumber={previousSerialSoundcardNumber}
              importedSerialNumber={importedSerialNumber}
              importedSoundcardSerialNumber={importedSoundcardSerialNumber}
              handleSerialNumberChange={handleSerialNumberChange}
              isImportMode={isImportMode}
              maj={maj}
              setMaj={setMaj}
            />
          )}
          {loading && <Loader />}
          {success && <Success success={t("calibration_data.calibration_data_updated")} />}
        </div>
      </div>
    </>
  );
};

export default OperatorCalib;
